import { Search, Star, MessageCircle, ShoppingBag } from 'lucide-react';
import type { Translations } from '../types';

interface FeaturesProps {
  t: Translations;
}

export function Features({ t }: FeaturesProps) {
  const features = [
    {
      icon: Search,
      title: t.discover,
      description: t.discoverDesc,
    },
    {
      icon: ShoppingBag,
      title: t.marketplace,
      description: t.marketplaceDesc,
    },
    {
      icon: Star,
      title: t.review,
      description: t.reviewDesc,
    },
    {
      icon: MessageCircle,
      title: t.connect,
      description: t.connectDesc,
    },
  ];

  return (
    <section id="features" className="py-12 sm:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-16">
          <h2 className="mb-4">{t.howConnect}</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">{t.howConnectDesc}</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature) => (
            <div key={feature.title} className="text-center p-8">
              <div className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4 bg-vinotinto-subtle">
                <feature.icon className="w-8 h-8 text-vinotinto" />
              </div>
              <h3 className="mb-3 text-xl font-semibold">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
